import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ExposureBySEGs } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

interface ExposureBySEGsVm extends ExposureBySEGs {
  changeAbs: number;
  isChangeAlertVm: boolean;
  showUpArrow: boolean;
  showDownArrow: boolean;
}

@Component({
  standalone: false,
  selector: 'app-exposures-by-segs',
  templateUrl: './exposures-by-segs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposures-by-segs.component.scss']
})
export class ExposuresBySegsComponent implements OnInit {
  exposureBySEGsVm: ExposureBySEGsVm[] = [];

  @Input() set exposureBySEGs(value: ExposureBySEGs[]) {
    this.exposureBySEGsVm = (value || []).map(seg => ({
      ...seg,
      changeAbs: Math.abs(seg?.change ?? 0),
      isChangeAlertVm: this.computeChangeAlert(seg),
      showUpArrow: !!(seg?.change && seg.change > 0),
      showDownArrow: !seg?.change || seg.change < 0,
    }));
  }
  @Input() loading: boolean = true;

  @Input() segSort: string = "change";
  @Input() segOrder: string = "desc";

  @Output() sortSEGEmit = new EventEmitter<any>();
  @Output() showSEGDetailEmit = new EventEmitter<ExposureBySEGs>();
  @Output() showAllPopupEmit = new EventEmitter<any>();
  @Input() showSegReport: boolean = true;

  showInfo: boolean = false;
  showAllPopup: boolean = false;
  errorMessage: string = "";
  colors: any = this.commonService.colors;

  constructor(
    private commonService: CommonService,
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  private computeChangeAlert(seg: ExposureBySEGs): boolean {
    const prev = (seg as any)?.previousRiskCategory;
    const curr = seg?.riskCategory;
    if (prev && curr) {
      if (
        (prev == 'Low' && ['Medium', 'High', 'Ultra-High'].includes(curr)) ||
        (prev == 'Medium' && ['High', 'Ultra-High'].includes(curr)) ||
        (prev == 'High' && ['Ultra-High'].includes(curr))
      ) {
        return true;
      }
    }
    return false;
  }

  showAllPopupFn() {
    this.showAllPopupEmit.emit(true);
  }

  showSEGDetailFn(seg: ExposureBySEGs) {
    this.showSEGDetailEmit.emit(seg)
  }

  toggleInfo(show: boolean) {
    this.showInfo = show;
  }

  sortSEG(segAllSort: any) {
    this.sortSEGEmit.emit(segAllSort);
  }

  public trackByIndex = trackByIndex;
}
